import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { AddCallTheme } from 'modules/theme';
import { connect } from 'react-redux';
import { globalStateSelector } from 'store/selector';
import { globalAction, callAction, messageAction } from 'store/action';

export class AddCall extends Component {
  constructor(props){
    super(props);
    this.onTransfer = this.onTransfer.bind(this);
    this.onTeamSelect = this.onTeamSelect.bind(this);
    this.onTeamUnSelect = this.onTeamUnSelect.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.onTransferTab = this.onTransferTab.bind(this);
    this.state = {
      transferList : [],
      phoneNumber : ""
    };
  }
  componentWillReceiveProps(nextProps) {
    if( typeof nextProps.transferList != "undefined" ){
      this.setState({"transferList" : nextProps.transferList });
    }
  }
  getTeamList( team ) {
    const { teamList } = this.props;
    let teamId  = team && team.id ? team.id : "";
    let list = [];
    let selectedTeam = teamList.filter(e=>{
      return e._id == teamId;
    });
    if( selectedTeam && selectedTeam[0] && selectedTeam[0].teamLists && selectedTeam[0].teamLists.length ){
      selectedTeam[0].teamLists.forEach((el)=>{
        list.push({
          image: '/images/icons/user-group-woman-woman.png',
          status : 'active',
          name : el.name,
          width : '30px',
          username : el.name,
          info : "",
          id : el._id
        })
      })
    }
    return list;
  }
  getFlowList( team ) {
    const { teamList } = this.props;
    let teamId  = team && team.id ? team.id : "";
    let list = [];
    let selectedTeam = teamList.filter(e=>{
      return e._id == teamId;
    });
    if( selectedTeam && selectedTeam[0] && selectedTeam[0].initFlowList && selectedTeam[0].initFlowList.length ){
      selectedTeam[0].initFlowList.map((el)=>{
        list.push({
          image: '/images/icons/tree-structure.png',
          width : '30px',
          status : 'active',
          type : 'flow',
          name : el.name,
          username : el.name,
          info : "",
          id : el._id
        })
      })
    }
    return list;
  }
  getList( transferList ) {
    let list = [];
    if( transferList ) {
      for (const key in transferList) {
        if (Object.hasOwnProperty.call(transferList, key)) {
          const agent = transferList[key];
          list.push({
            image: 'images/icons/guest-male.png',
            status : 'active',
            width : '40px',
            name : agent.name,
            username : agent.username,
            info : "",
            id : agent.id
          })
        }
      }
    }
    return list; 
  }
  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  startTimer( state, timer  ){
    timer = timer || 10000;
    const { dynamicUpdate } = this.props;
    dynamicUpdate({ key: 'callHandlingState', value: state});
    clearTimeout(global.__btnTimer)
    global.__btnTimer = setTimeout(() => {
      dynamicUpdate({ key: 'callHandlingState', value: "" });
    }, 10000);;
  }
  onTransferTab( transferTab ) {
    const { dynamicUpdate, configProcessor, team, callTeam } = this.props;
    // agent
    // team
    // phoneno
    dynamicUpdate({ key: 'transferTab', value: transferTab});
    if( transferTab != "team" ){
      dynamicUpdate({ key: 'transferSelectedTeam', value: {}});
      dynamicUpdate({ key: 'transferList', value: []});
      let teamId  = callTeam && callTeam.id ? callTeam.id : team._id;
      configProcessor(`liveMonitor`,{
        "teamId" : teamId,
        "transfer" : "AGENT"
      });
    } else {

    }
  }
  onTeamUnSelect() {
    const { dynamicUpdate, configProcessor, team, callTeam } = this.props;
    let teamId  = callTeam && callTeam.id ? callTeam.id : team._id;
    dynamicUpdate({ key: 'transferSelectedTeam', value: {}});
    dynamicUpdate({ key: 'transferList', value: []});
    configProcessor(`liveMonitor`,{
      "teamId" : teamId,
      "transfer" : "AGENT"
    });
  }
  onTeamSelect( params ) {
    const { dynamicUpdate, configProcessor } = this.props;
    if( params.name && params.id ){
      dynamicUpdate({ key: 'transferSelectedTeam', value: {
        name : params.name,
        id : params.id,
      }});
      dynamicUpdate({ key: 'transferList', value: []});
      configProcessor(`liveMonitor`,{
        "teamId" : params.id,
        "transfer" : "AGENT"
      });
    } else {
      console.log("Transfer Team info not proper");
    }
  }
  onTransfer( params ) {
    const { callInfo, dynamicUpdate, team, callTeam } = this.props
    let teamId  = callTeam && callTeam.id ? callTeam.id : team._id;
    let callType  = params.type || "";
    dynamicUpdate({ key: 'transferInfo', value: params });
    if( callType == "flow" ){
      this.startTimer("txAgentLoader",45000);
      this.sendMessage('callTransferFlow', {
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId,
        callId2: callInfo.custId,
        flow : {
          name : params.name,
          id : params.id,
        }
      });
    } else if( callType == "externalNumber" ){
      this.startTimer("txAgentLoader",45000);
      this.sendMessage('callTransferTalk', {
        teamId: teamId,
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId,
        type: "phone",
        phone : params.phone
      });
    } else {
      this.startTimer("txAgentLoader");
      this.sendMessage('callTransferTalk', {
        teamId: teamId,
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId,
        type: "agent",
        agentId : params.id
      });
    }
  }
  render() {
    const {
      transferList,
      transferId,
      callState,
      callTeam,
      transferTab,
      transferSelectedTeam
    } = this.props;
    const list = this.getList( transferList );
    const teamList = this.getTeamList( callTeam );
    const flowList = this.getFlowList( callTeam );
    return (
      <AddCallTheme 
        key={transferId}
        title={`Add Call`}
        list={list} 
        teamList={teamList} 
        flowList={flowList} 
        callState={callState} 
        transferSelectedTeam={transferSelectedTeam}
        onTransfer={this.onTransfer} 
        onTeamUnSelect={this.onTeamUnSelect} 
        onTeamSelect={this.onTeamSelect} 
        onTransferTab={this.onTransferTab} 
        transferTab={transferTab} 
        phoneNumber={this.state.phoneNumber}
        onPhoneChange={( phoneNumber )=>{
          this.setState({"phoneNumber":phoneNumber})
        }} 
      />
    )
  }
}

AddCall.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  callInfo: globalStateSelector.getInfo(state),
  transferList: globalStateSelector.getDynamic(state, { key: 'transferList' }),
  transferId: globalStateSelector.getDynamic(state, { key: 'transferId' }),
  team: globalStateSelector.getSelectedTeam(state),
  callTeam: globalStateSelector.getDynamic(state, { key: 'callTeam' }),
  teamList: globalStateSelector.getTeamList(state),
  callState: globalStateSelector.getDynamic(state, { key: 'callHandlingState' }),
  transferSelectedTeam: globalStateSelector.getDynamic(state, { key: 'transferSelectedTeam' }),
  transferTab: globalStateSelector.getDynamic(state, { key: 'transferTab' }),
});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  }
});
export default connect(stateToProps, dispatchToProps)(AddCall);


// WEBPACK FOOTER //
// src/dialpad/components/layout/AddCall.js